import { useEffect, useState } from 'react';

/**
 * Measure how many pixels of the viewport the on-screen keyboard
 * is currently covering. Returns 0 when no keyboard is open.
 *
 * Used by modals that stay `position: fixed` on screen so they can
 * translateY themselves up by part of the keyboard height instead
 * of being hidden behind it. Only active while `enabled` is true
 * so modals don't keep listeners around when closed.
 *
 * The 120 px floor filters out Chrome's address-bar collapse, which
 * also shrinks visualViewport.height but isn't a keyboard.
 */
export function useKeyboardOffset(enabled) {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    if (!enabled || typeof window === 'undefined' || !window.visualViewport) return undefined;
    const vv = window.visualViewport;
    const check = () => {
      const delta = Math.max(0, window.innerHeight - vv.height);
      setOffset(delta > 120 ? delta : 0);
    };
    check();
    vv.addEventListener('resize', check);
    vv.addEventListener('scroll', check);
    return () => {
      vv.removeEventListener('resize', check);
      vv.removeEventListener('scroll', check);
    };
  }, [enabled]);
  return offset;
}
